import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const CertificateDestitute = () => {
  const { language } = useLanguage();
  
  const [formData, setFormData] = useState({
    // Applicant Information
    applicantName: '',
    mobileNumber: '',
    
    // Destitute Certificate Details
    applicantNameMarathi: '',
    applicantNameEnglish: '',
    dateOfBirth: '',
    aadharNumber: '',
    ageProof: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Age validation
    if (formData.dateOfBirth) {
      const birthDate = new Date(formData.dateOfBirth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      
      if (age < 60) {
        alert(language === 'marathi' 
          ? 'कृपया लक्ष द्या: वय 60 वर्षांपेक्षा कमी आहे. निराधार दाखल्यासाठी किमान वय 60 वर्षे असणे आवश्यक आहे.' 
          : 'Please note: Age is less than 60 years. Minimum age of 60 years is required for destitute certificate.');
        return;
      }
    }
    
    console.log('Form submitted:', formData);
    // Handle form submission logic here
  };

  const handleReset = () => {
    setFormData({
      applicantName: '',
      mobileNumber: '',
      applicantNameMarathi: '',
      applicantNameEnglish: '',
      dateOfBirth: '',
      aadharNumber: '',
      ageProof: null,
    });
  };

  const formSectionStyle = {
    background: 'linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid #ffd43b',
    boxShadow: '0 2px 10px rgba(255, 193, 7, 0.1)',
  };

  const inputStyle = {
    background: '#ffffff',
    border: '1px solid #ffc107',
    borderRadius: '6px',
    padding: '10px 15px',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    width: '100%',
  };

  const labelStyle = {
    color: '#856404',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px',
    display: 'block',
  };

  const sectionTitleStyle = {
    color: '#856404',
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #ffc107',
    textAlign: 'center',
    background: 'linear-gradient(90deg, #ffc107 0%, #856404 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  };

  const requiredStar = {
    color: '#dc3545',
    marginLeft: '3px',
    fontWeight: 'bold',
  };

  const helpTextStyle = {
    color: '#856404',
    fontSize: '12px',
    fontStyle: 'italic',
    marginTop: '4px',
    display: 'block',
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-amber-50 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Form Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-amber-600 to-orange-600 mb-4">
            <span className="text-3xl text-white">👴</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            {language === 'marathi' ? 'निराधार दाखला मागणी फॉर्म' : 'Destitute Certificate Request Form'}
          </h1>
          <p className="text-gray-600">
            {language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत - वृद्ध / निराधार प्रमाणपत्र' : 'Inam Dhamani Gram Panchayat - Old Age / Destitute Certificate'}
          </p>
          <div className="mt-4 w-24 h-1 bg-gradient-to-r from-amber-500 to-orange-500 mx-auto rounded-full"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Section 1: Applicant Information */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'अर्जदार माहिती तपशील' : 'Applicant Information Details'}</h2>
            
            <div className="space-y-6">
              {/* Field 1: Applicant Name */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदार नाव' : 'Applicant Name'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantName"
                  value={formData.applicantName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'अर्ज करणाऱ्या व्यक्तीचे संपूर्ण नाव प्रविष्ट करा' : 'Enter the full name of the applicant'}
                  className="focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'अर्ज करणाऱ्या व्यक्तीचे संपूर्ण नाव प्रविष्ट करा' : 'Enter the full name of the applicant'}
                </span>
              </div>

              {/* Field 2: Mobile Number */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मोबाईल क्रमांक' : 'Mobile Number'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'अर्जदाराचा संपर्कासाठी मोबाईल क्रमांक प्रविष्ट करा' : 'Enter applicant\'s contact mobile number'}
                  pattern="[0-9]{10}"
                  maxLength="10"
                  className="focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? '10 अंकी मोबाईल क्रमांक प्रविष्ट करा' : 'Enter 10-digit mobile number'}
                </span>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t-2 border-amber-300"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="px-4 bg-gradient-to-r from-yellow-50 to-amber-50 text-amber-700 font-bold text-sm">
                {language === 'marathi' ? '🔸 निराधार दाखला मागणी तपशील 🔸' : '🔸 Destitute Certificate Request Details 🔸'}
              </span>
            </div>
          </div>

          {/* Section 2: Destitute Certificate Details */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'निराधार दाखला मागणी तपशील' : 'Destitute Certificate Request Details'}</h2>
            
            <div className="space-y-6">
              {/* Field 3: Applicant Name in Marathi */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदार नाव (मराठी मध्ये)' : 'Applicant Name (in Marathi)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantNameMarathi"
                  value={formData.applicantNameMarathi}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'अर्जदाराचे संपूर्ण नाव मराठी मध्ये प्रविष्ट करा' : 'Enter applicant\'s full name in Marathi'}
                  className="focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'अर्जदाराचे संपूर्ण नाव मराठी मध्ये प्रविष्ट करा' : 'Enter applicant\'s full name in Marathi'}
                </span>
              </div>

              {/* Field 4: Applicant Name in English */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदार नाव (इंग्रजी मध्ये)' : 'Applicant Name (in English)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantNameEnglish"
                  value={formData.applicantNameEnglish}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'अर्जदाराचे संपूर्ण नाव इंग्रजी मध्ये प्रविष्ट करा' : 'Enter applicant\'s full name in English'}
                  className="focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'अर्जदाराचे संपूर्ण नाव इंग्रजी मध्ये प्रविष्ट करा' : 'Enter applicant\'s full name in English'}
                </span>
              </div>

              {/* Field 5: Date of Birth */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'जन्म दिनांक' : 'Date of Birth'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  className="focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'dd-mm-yyyy (किमान वय 60 वर्षे असणे आवश्यक)' : 'dd-mm-yyyy (minimum age 60 years required)'}
                </span>
                {formData.dateOfBirth && (() => {
                  const birthDate = new Date(formData.dateOfBirth);
                  const today = new Date();
                  let age = today.getFullYear() - birthDate.getFullYear();
                  const monthDiff = today.getMonth() - birthDate.getMonth();
                  
                  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                  }
                  
                  if (age < 60) {
                    return (
                      <span style={{color: '#dc3545', fontSize: '12px', fontWeight: 'bold', marginTop: '4px', display: 'block'}}>
                        {language === 'marathi' 
                          ? `⚠️ चेतावणी: वय ${age} वर्षे आहे. निराधार दाखल्यासाठी किमान वय 60 वर्षे असणे आवश्यक आहे.` 
                          : `⚠️ Warning: Age is ${age} years. Minimum age of 60 years is required for destitute certificate.`}
                      </span>
                    );
                  }
                  return (
                    <span style={{color: '#28a745', fontSize: '12px', fontWeight: 'bold', marginTop: '4px', display: 'block'}}>
                      {language === 'marathi' ? `✓ वय ${age} वर्षे आहे (पात्र)` : `✓ Age is ${age} years (Eligible)`}
                    </span>
                  );
                })()}
              </div>

              {/* Field 6: Aadhar Number */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'आधार नंबर' : 'Aadhar Number'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="aadharNumber"
                  value={formData.aadharNumber}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? '12 अंकी आधार क्रमांक प्रविष्ट करा' : 'Enter 12-digit Aadhar number'}
                  pattern="[0-9]{12}"
                  maxLength="12"
                  className="focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? '12 अंकी आधार क्रमांक प्रविष्ट करा' : 'Enter 12-digit Aadhar number'}
                </span>
                {formData.aadharNumber && formData.aadharNumber.length !== 12 && (
                  <span style={{color: '#dc3545', fontSize: '12px', marginTop: '4px', display: 'block'}}>
                    {language === 'marathi' ? '⚠️ आधार क्रमांक 12 अंकी असावा' : '⚠️ Aadhar number should be 12 digits'}
                  </span>
                )}
              </div>

              {/* Field 7: Age Proof Document */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'वयाचा दाखला' : 'Age Proof'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="file"
                  name="ageProof"
                  onChange={handleChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                  required
                  className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-amber-50 file:text-amber-700 hover:file:bg-amber-100"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'PDF / JPG / PNG स्वरूपात (कमाल आकार: 2 MB)' : 'In PDF / JPG / PNG format (Max size: 2 MB)'}
                </span>
              </div>
            </div>
          </div>

          {/* Eligibility Check */}
          <div className="p-4 bg-gradient-to-r from-amber-100 to-yellow-100 border border-amber-300 rounded-lg">
            <h3 className="font-bold text-amber-800 mb-2">{language === 'marathi' ? '📋 पात्रता तपशील:' : '📋 Eligibility Details:'}</h3>
            <ul className="list-disc pl-5 text-sm text-amber-700 space-y-1">
              <li>{language === 'marathi' ? 'वय 60 वर्षांपेक्षा जास्त असणे आवश्यक' : 'Must be over 60 years of age'}</li>
              <li>{language === 'marathi' ? 'कुटुंबात कोणीही कमावत नसणे' : 'No earning member in the family'}</li>
              <li>{language === 'marathi' ? 'सरकारी पेन्शन नसणे' : 'No government pension'}</li>
              <li>{language === 'marathi' ? 'कोणत्याही सरकारी नोकरीत नसणे' : 'Not in any government job'}</li>
              <li>{language === 'marathi' ? 'ग्रामपंचायत क्षेत्रातील कायम निवासी असणे' : 'Permanent resident of Gram Panchayat area'}</li>
            </ul>
          </div>

          {/* Form Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6">
            <button
              type="submit"
              style={{
                background: 'linear-gradient(135deg, #ffc107 0%, #e0a800 100%)',
                color: '#856404',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(255, 193, 7, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
              onMouseEnter={(e) => {
                e.target.style.boxShadow = '0 6px 20px rgba(255, 193, 7, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = '0 4px 15px rgba(255, 193, 7, 0.3)';
              }}
            >
              📄 {language === 'marathi' ? 'निराधार दाखला मागवा' : 'Request Destitute Certificate'}
            </button>

            <button
              type="button"
              onClick={handleReset}
              style={{
                background: 'linear-gradient(135deg, #6c757d 0%, #545b62 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(108, 117, 125, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
              onMouseEnter={(e) => {
                e.target.style.boxShadow = '0 6px 20px rgba(108, 117, 125, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = '0 4px 15px rgba(108, 117, 125, 0.3)';
              }}
            >
              🔄 {language === 'marathi' ? 'पुन्हा सुरू करा' : 'Reset'}
            </button>
          </div>

          {/* Form Footer */}
          <div className="mt-8 text-center text-sm text-gray-600">
            <p className="mb-2">
              <span style={{color: '#dc3545', fontWeight: 'bold'}}>*</span> {language === 'marathi' ? 'हे चिन्ह असलेले फील्ड अनिवार्य आहेत' : 'Fields marked with this symbol are mandatory'}
            </p>
            <p>
              {language === 'marathi' 
                ? 'अर्ज सादर केल्यानंतर, तुम्हाला एक अर्ज संदर्भ क्रमांक प्राप्त होईल. कृपया तो संदर्भ क्रमांक नोंदवून ठेवा.'
                : 'After submitting the application, you will receive an application reference number. Please note down that reference number.'}
            </p>
          </div>
        </form>

        {/* Information Box */}
        <div className="mt-10 p-6 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg">
          <h3 className="text-lg font-semibold text-amber-800 mb-3">{language === 'marathi' ? '👴 निराधार दाखल्याची माहिती:' : '👴 Destitute Certificate Information:'}</h3>
          <ul className="list-disc pl-5 space-y-2 text-amber-700">
            <li className="font-medium">{language === 'marathi' ? 'निराधार दाखला हा वृद्ध, अनाथ आणि निराधार व्यक्तींसाठी असतो' : 'Destitute certificate is for elderly, orphans and destitute persons'}</li>
            <li className="font-medium">{language === 'marathi' ? 'या दाखल्यावरून सरकारी योजनांचा लाभ मिळू शकतो' : 'Government scheme benefits can be availed from this certificate'}</li>
            <li className="font-medium">{language === 'marathi' ? 'निराधार पेन्शन योजनेसाठी हा दाखला आवश्यक असतो' : 'This certificate is required for destitute pension scheme'}</li>
            <li className="font-medium">{language === 'marathi' ? 'आवश्यक कागदपत्रे: आधार कार्ड, वय प्रमाणपत्र, राहण्याचा पुरावा' : 'Required documents: Aadhar card, age certificate, residence proof'}</li>
            <li className="font-medium">{language === 'marathi' ? 'अर्ज सादर केल्यानंतर 7-10 कामकाजाच्या दिवसात दाखला तयार होईल' : 'Certificate will be ready in 7-10 working days after application submission'}</li>
          </ul>
          
          <div className="mt-4 pt-4 border-t border-amber-300">
            <h4 className="font-bold text-amber-800 mb-2">{language === 'marathi' ? '💰 निराधार पेन्शन:' : '💰 Destitute Pension:'}</h4>
            <p className="text-amber-700 text-sm">
              {language === 'marathi' 
                ? 'निराधार दाखला मंजूर झाल्यानंतर, ₹१०००/- प्रतिमाह पेन्शन मिळू शकते.'
                : 'After destitute certificate is approved, a pension of ₹1000/- per month can be received.'}
            </p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="mt-6 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            <div className="text-center sm:text-left">
              <p className="text-sm font-semibold text-gray-700">{language === 'marathi' ? '📞 संपर्क क्रमांक:' : '📞 Contact Number:'}</p>
              <p className="text-gray-600">{language === 'marathi' ? '०२४१-XXXXXXX (सामाजिक कल्याण विभाग)' : '0241-XXXXXXX (Social Welfare Department)'}</p>
            </div>
            <div className="hidden sm:block h-8 w-px bg-gray-300"></div>
            <div className="text-center sm:text-left">
              <p className="text-sm font-semibold text-gray-700">✉️ ईमेल:</p>
              <p className="text-gray-600">destitute@inamdhamani-grampanchayat.in</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateDestitute;